module.exports = __webpack_public_path__ + "static/media/zach.81dd6727.jpg";